export const CreditCardIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.33"
      strokeMiterlimit="10"
      strokeLinecap="square"
      {...props}
    >
      <path d="M0.666504 4.66675H15.3332" />
      <path d="M0.666504 7.33325H15.3332" />
      <path d="M13.9998 14H1.99984C1.26317 14 0.666504 13.4033 0.666504 12.6667V3.33333C0.666504 2.59667 1.26317 2 1.99984 2H10.6665H13.9998C14.7365 2 15.3332 2.59667 15.3332 3.33333V12.6667C15.3332 13.4033 14.7365 14 13.9998 14Z" />
      <path d="M3.3335 10.6667H6.66683" />
      <path d="M12 10.6667H12.6667" />
    </svg>
  );
};
